import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from "react-router-dom";
import AuthService from '../services/auth.service';
import Submit from '../components/submit-button';

function Login() {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState<any>({});
    const [showPassword, setShowPassword] = useState(false);
    const [isChecked, setIsChecked] = useState(false)
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        mobile: "",
        password: "",
        agree: false
    });

    const checkHandler = () => {
        setIsChecked(!isChecked)
        setFormData({
            ...formData,
            ['agree']: !isChecked
        });
    }

    const handleShowPassword = () => {
        setShowPassword(showPassword ? false : true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        // if (name === 'mobile' && isNaN(e.target.value)) {
        //   return false
        // }

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors: any = {};

        if (!formData.mobile) {
            newErrors.mobile = "Email /Mobile no. is required";
            isValid = false;
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
            isValid = false;
        }
        if (!formData.agree) {
            newErrors.agree = "Please accept terms";
            isValid = false;
        }

        if (!isValid) {
            setLoading(false);
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (loading) return;
        setMessage('');
        setLoading(true);

        if (validateForm()) {
            AuthService.login(formData).then(
                (response) => {
                    //alert(response?.message)
                    if (response?.status === 200) {
                        setMessage(response?.message);
                        navigate('/');
                    } else {
                        setMessage(response?.message);
                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);
                //alert(error)
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    return (
        <>
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  mt-3">
                        <div className='loginForms'>
                            <h1>Welcome Back Login Here </h1>
                            <form onSubmit={handleSubmit}>
                                <label className='mt-4'>Email Id /Phone Number <sup style={{ color: '#F75653' }}>*</sup></label>
                                <input
                                    type="text"
                                    placeholder='Email/Phone Number'
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={(e) => handleInputChange(e)}
                                    autoComplete='off'
                                />
                                {errors.mobile && <div className="invalid">{errors.mobile}</div>}

                                <label className='mt-4'>Password <sup style={{ color: '#F75653' }}>*</sup></label>
                                <div className='passwordBtn'  >
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder='Enter Password'
                                        className="form-control"
                                        name="password"
                                        autoComplete='off'
                                        value={formData.password}
                                        onChange={(e) => handleInputChange(e)}
                                    />
                                    <button type="button" onClick={handleShowPassword}>
                                        {showPassword ?
                                            <svg width="14" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z"></path>
                                            </svg>
                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                                                <path d="M0.849854 6.5C1.41772 3.3 4.12835 0.875004 7.3857 0.875004C10.6431 0.875004 13.3531 3.3 13.9216 6.5C13.3537 9.7 10.6431 12.125 7.3857 12.125C4.12835 12.125 1.41832 9.7 0.849854 6.5ZM7.3857 9.625C8.1868 9.625 8.95509 9.29576 9.52155 8.70971C10.088 8.12366 10.4062 7.32881 10.4062 6.5C10.4062 5.6712 10.088 4.87635 9.52155 4.29029C8.95509 3.70424 8.1868 3.375 7.3857 3.375C6.58461 3.375 5.81632 3.70424 5.24986 4.29029C4.6834 4.87635 4.36516 5.6712 4.36516 6.5C4.36516 7.32881 4.6834 8.12366 5.24986 8.70971C5.81632 9.29576 6.58461 9.625 7.3857 9.625ZM7.3857 8.375C6.90505 8.375 6.44407 8.17746 6.1042 7.82583C5.76432 7.4742 5.57338 6.99728 5.57338 6.5C5.57338 6.00272 5.76432 5.52581 6.1042 5.17418C6.44407 4.82255 6.90505 4.625 7.3857 4.625C7.86636 4.625 8.32734 4.82255 8.66721 5.17418C9.00709 5.52581 9.19803 6.00272 9.19803 6.5C9.19803 6.99728 9.00709 7.4742 8.66721 7.82583C8.32734 8.17746 7.86636 8.375 7.3857 8.375Z" fill="white" />
                                            </svg>

                                        }
                                    </button>
                                </div>
                                <Link to="/forgot-password" className='Forgot'>Forgot Password</Link>
                                {errors.password && <div className="invalid">{errors.password}</div>}

                                <div className='castomCheck'>
                                    <label className="form-control">
                                        <input type="checkbox" name="agree" checked={formData.agree} onChange={checkHandler} />
                                        <p className='d-block'>I agree to the User Agreement &  confirm I am at least 18 years old and receive marketing promotions from <span>74Win</span></p>
                                    </label>
                                    {errors.agree && <div className="invalid">{errors.agree}</div>}
                                </div>

                                {message && <div className="invalid text-center">{message}</div>}
                                <Submit buttonText={'Submit'} loading={loading} />

                                <div className='signUpwith'>
                                    <h5>or Sign up with</h5>
                                    <ul>
                                        <li>
                                            <button>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <g clipPath="url(#clip0_315_593)">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="#1877F2" />
                                                        <path d="M16.6711 15.9688L17.2031 12.5H13.875V10.25C13.875 9.30078 14.3391 8.375 15.8297 8.375H17.3438V5.42188C17.3438 5.42188 15.9703 5.1875 14.6578 5.1875C11.9156 5.1875 10.125 6.84922 10.125 9.85625V12.5H7.07812V15.9688H10.125V24.3547C10.7367 24.4508 11.3625 24.5 12 24.5C12.6375 24.5 13.2633 24.4508 13.875 24.3547V15.9688H16.6711Z" fill="white" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_315_593">
                                                            <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </li>
                                        <li>
                                            <button>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                                                    <path d="M18.3233 16.2571C18.0863 16.8022 17.8057 17.3039 17.4807 17.7651C17.0377 18.3939 16.6749 18.8291 16.3954 19.0708C15.962 19.4676 15.4977 19.6707 15.0005 19.6823C14.6436 19.6823 14.2131 19.5812 13.7121 19.3761C13.2093 19.1719 12.7473 19.0708 12.3249 19.0708C11.8819 19.0708 11.4067 19.1719 10.8985 19.3761C10.3895 19.5812 9.97947 19.6881 9.66596 19.6987C9.18917 19.7189 8.71393 19.5099 8.23956 19.0708C7.93679 18.808 7.55808 18.3573 7.10441 17.7189C6.61766 17.0371 6.21748 16.2466 5.90397 15.3452C5.56822 14.3717 5.3999 13.429 5.3999 12.5163C5.3999 11.4709 5.62683 10.5692 6.08138 9.81358C6.43861 9.20664 6.91385 8.72787 7.50865 8.3764C8.10346 8.02493 8.74614 7.84582 9.43826 7.83436C9.81696 7.83436 10.3136 7.95097 10.9307 8.18015C11.5461 8.4101 11.9413 8.52671 12.1145 8.52671C12.2441 8.52671 12.683 8.39036 13.4272 8.11852C14.1309 7.86643 14.7248 7.76205 15.2114 7.80316C16.5298 7.90909 17.5204 8.42647 18.1791 9.35859C17 10.0698 16.4167 11.066 16.4283 12.3439C16.4389 13.3393 16.8017 14.1676 17.5146 14.8253C17.8377 15.1305 18.1985 15.3664 18.5999 15.534C18.5128 15.7853 18.4209 16.026 18.3233 16.2571ZM15.2994 4.41209C15.2994 5.19227 15.0131 5.92072 14.4424 6.59497C13.7536 7.39652 12.9206 7.85969 12.0172 7.7866C12.0057 7.693 11.999 7.59449 11.999 7.49098C11.999 6.74201 12.3266 5.94046 12.9082 5.28509C13.1986 4.95326 13.5679 4.67735 14.0158 4.45726C14.4627 4.24044 14.8854 4.12054 15.283 4.10001C15.2946 4.2043 15.2994 4.30861 15.2994 4.41208V4.41209Z" fill="white" />
                                                </svg>
                                            </button>
                                        </li>
                                        <li>
                                            <button>
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M19.404 12.6773C19.404 12.1242 19.3544 11.5924 19.2622 11.0818H11.916V14.099H16.1138C15.933 15.074 15.3835 15.9001 14.5574 16.4532V18.4103H17.0782C18.5531 17.0524 19.404 15.0527 19.404 12.6773Z" fill="#4285F4" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9162 20.3C14.0222 20.3 15.7878 19.6015 17.0783 18.4103L14.5575 16.4532C13.8591 16.9212 12.9656 17.1977 11.9162 17.1977C9.88462 17.1977 8.16507 15.8256 7.55171 13.982H4.9458V16.0029C6.22925 18.5521 8.86707 20.3 11.9162 20.3Z" fill="#34A853" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.55151 13.982C7.39551 13.514 7.30688 13.0141 7.30688 12.5C7.30688 11.9859 7.39551 11.486 7.55151 11.018V8.99707H4.9456C4.41733 10.0501 4.11597 11.2413 4.11597 12.5C4.11597 13.7586 4.41733 14.9499 4.9456 16.0029L7.55151 13.982Z" fill="#FBBC05" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9162 7.80228C13.0613 7.80228 14.0895 8.19583 14.8979 8.96874L17.1351 6.73156C15.7843 5.47292 14.0186 4.70001 11.9162 4.70001C8.86707 4.70001 6.22926 6.44792 4.9458 8.9971L7.55171 11.018C8.16507 9.17437 9.88462 7.80228 11.9162 7.80228Z" fill="#EA4335" />
                                                </svg>

                                            </button>
                                        </li>
                                        <li>
                                            <button>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#1D9BF0" />
                                                    <path d="M9.80408 18.83C15.1261 18.83 18.0361 14.42 18.0361 10.598C18.0361 10.472 18.0361 10.346 18.0301 10.226C18.5941 9.818 19.0861 9.308 19.4761 8.726C18.9601 8.954 18.4021 9.11 17.8141 9.182C18.4141 8.822 18.8701 8.258 19.0861 7.58C18.5281 7.91 17.9101 8.15 17.2501 8.282C16.7221 7.718 15.9721 7.37 15.1381 7.37C13.5421 7.37 12.2461 8.666 12.2461 10.262C12.2461 10.49 12.2701 10.712 12.3241 10.922C9.91808 10.802 7.78808 9.65 6.36008 7.898C6.11408 8.324 5.97008 8.822 5.97008 9.35C5.97008 10.352 6.48008 11.24 7.26008 11.756C6.78608 11.744 6.34208 11.612 5.95208 11.396C5.95208 11.408 5.95208 11.42 5.95208 11.432C5.95208 12.836 6.94808 14 8.27408 14.27C8.03408 14.336 7.77608 14.372 7.51208 14.372C7.32608 14.372 7.14608 14.354 6.96608 14.318C7.33208 15.47 8.40008 16.304 9.66608 16.328C8.67608 17.102 7.42808 17.564 6.07208 17.564C5.83808 17.564 5.61008 17.552 5.38208 17.522C6.64808 18.35 8.17208 18.83 9.80408 18.83Z" fill="white" />
                                                </svg>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <h6 className='mt-3 text-center'>Don't have an Account? <Link to="/register" style={{ background: 'none', textDecoration: 'none' }}><span className='textGradient'>Register</span></Link></h6>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login;